import { IConfigModule } from "build/types/configs";

const config : IConfigModule = {
  "version": "2.0.0",
  "filterPrizes": true,
  "comingSoon": false,
  "buttonsStart": ['xeerpa'],
  "positiveLogoUrls": [],
  "useSecondBackground": [],
  "imageStart": "backgroundImage",
  "welcome": "ImgBackground",
  "legalAgeDate": true,
  "routesLinks": [],
  "routesHome": [
    "BohemiaID",
    "BohemiaIntercambioNav"
  ],
  "routesProfile": [
    "information",
    "address",
    "phone",
    "identificacion"
  ],
  "notAvailableFields": [
    "instagram",
    "interests",
    "nickName",
    "consumptionCenter",
    "sign"
  ],
  "backgroundWhite": true,
  "trivia": {
    "showIntroduction": false,
    "interestsRequired": false
  },
  "notShowFields": [
    "instagram"
  ],
  "loaderPulse": true,
  "album": {
    "Foto": {
      "list": {
        "handleClick": true,
        "urlRedirectAlbumComplete": "/album/:id/ranking",
        "urlRedirectAlbumProgress": "/album/:id/ranking"
      },
      "ranking": {
        "showSocial": "like",
        "titleUpload": true,
        "viewMore": true
      },
      "imageId": {
        "showSocial": "like"
      },
      "profile": {
        "showSocial": "like|share"
      },
      "upload": {
        "showHowToParticipate": true,
        "isTakeFoto": false,
        "useLoaderValidate": true,
        "validate": true
      }
    }
  },
  "uploaderType": [
    "WriteText"
  ],
  "congrats": {
    "showButton3": true
  },
  "stepsNewVersion": true,
  "profile": {
    "notShowButtonInformation": true,
    "showButtonPoints": false
  },
  "addressUpdateBg": true,
  "showModalMemorama": true,
  "memorama": {
    "dontShouldUseWhiteBg": true
  },
  "captureBtnBgTransparent": true,
  "allowReferral": false,
  "triviaQr": {
    "showImage": true
  }
}

export default config;